import TriggerBase from "./Base";
import {useState} from "react";
import {useTranslation} from "react-i18next";

const AreaTrigger = ({trigger, canUpdate, setAreaTriggerValue, setAreaTriggerHysteresis}) => {
    const { t } = useTranslation();
    const [hysteresis, setHysteresis] = useState(trigger.hysteresisPercent.toString().replace('.', ','));
    const [triggerValue, setTriggerValue] = useState(trigger.value);

    return (
        <>
            <TriggerBase trigger={trigger} />
            <tr>
                <td>{t("elementeAllgemein.area")}</td>
                <td>{trigger.areaName}</td>
            </tr>
            <tr>
                <td>{t("stateControllerService.valueField")}</td>
                <td>{trigger.valueField}</td>
            </tr>
            <tr>
                <td>{t("stateControllerService.comparisonMode")}</td>
                <td>{trigger.comparisonMode}</td>
            </tr>
            <tr>
                <td>{t("stateControllerService.valueNeeded")}</td>
                <td>
                    {canUpdate ?
                        <>
                            <input type="text" value={triggerValue} onChange={(e) => {setTriggerValue(e.target.value)}} style={{"width": "50px"}} />
                            <button className="button" style={{marginLeft: "10px"}} onClick={() => setAreaTriggerValue(trigger.areaId, triggerValue)}>
                                {t("allgemein.speichern")}
                            </button>
                        </>
                        : triggerValue
                    }</td>
            </tr>
            <tr>
                <td>{t("elementeAllgemein.hysterese")} [%]</td>
                <td>{
                    canUpdate ?
                        <>
                            <input type="text" value={hysteresis} onChange={(e) => {setHysteresis(e.target.value)}} style={{"width": "50px"}} />
                            <button className="button" style={{marginLeft: "10px"}} onClick={() => setAreaTriggerHysteresis(trigger.areaId, hysteresis)}>
                                {t("allgemein.speichern")}
                            </button>
                        </>
                        : hysteresis
                }</td>
            </tr>
        </>
    )
}

export default AreaTrigger
